import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import OkButton from '../atoms/OkButton';

const styles = {
  customProgressAnimation: {
    animation:
      'MuiCircularProgress-keyframes-circular-rotate 0.7s linear infinite'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openProgress,
    progressOkAction = null,
    loading,
    resultMessage = null
  }) => {
    return (
      <Dialog
        open={openProgress}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {!loading ? (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.breakLine}
            >
              {resultMessage}
            </DialogContentText>
          ) : (
            <Fade in={loading} unmountOnExit>
              <CircularProgress
                disableShrink
                className={classes.customProgressAnimation}
              />
            </Fade>
          )}
        </DialogContent>
        {!loading && resultMessage && (
          <DialogActions>
            <OkButton onClickAction={progressOkAction} color="default" />
          </DialogActions>
        )}
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
